<template>
    <div class="head-bar">
    <router-link class="logo-font" to="/"><img class="logo-img" :src="logoUrl" alt=""></router-link>
    <toolBar :show-right-menu="showRightMenu" class="tool-bar"
             @menuClick="$emit('menu-click')"></toolBar>
    </div>
</template>

<script>
import logo from '@/assets/icon/dimer.svg';
import toolBar from './toolBar';

export default {
  name: 'headBar',
  components: {
    toolBar,
  },
  props: {
    showRightMenu: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logoUrl: logo,
    };
  },
};
</script>

<style scoped>
  .head-bar{
    display: flex;
    justify-content: space-between;
}
  .logo-font{
    font-weight: bold;
    color: #fff;
    margin-top: 30px;
    margin-left: 6.7%;
    font-size: 40px;
  }
  .tool-bar{
    width: 500px;
    margin-top: 20px;
    margin-right: 100px;
  }
  .logo-img{
    width: 150px;
    position: absolute;
    top: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/components/headBar/index.vue